import { useEffect, useState } from "react";
import { useAuth } from "@es-tools/shared";
import { vendorRequest } from "./vendorApi";
import "./vendor-access.css";

export function VendorMicrosoftLogin() {
  const { apiBaseUrl } = useAuth();
  const [enabled, setEnabled] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    void vendorRequest<{ microsoftEnabled: boolean }>(
      apiBaseUrl,
      "vendor-identity",
      { signal: controller.signal },
    )
      .then((value) => setEnabled(value.microsoftEnabled))
      .catch(() => {});
    return () => controller.abort();
  }, [apiBaseUrl]);
  if (!enabled) return null;
  return (
    <form
      className="vendor-identity-login"
      onSubmit={(event) => {
        event.preventDefault();
        setBusy(true);
        setError("");
        void vendorRequest<{ authorizationUrl: string }>(
          apiBaseUrl,
          "vendor-identity/microsoft/start",
          { method: "POST", body: JSON.stringify({ email }) },
        )
          .then((value) => {
            const url = new URL(value.authorizationUrl);
            if (url.origin !== "https://login.microsoftonline.com")
              throw new Error("Invalid Microsoft sign-in destination.");
            window.location.assign(url.href);
          })
          .catch((err) => {
            setError(err.message);
            setBusy(false);
          });
      }}
    >
      <h2>Vendor Microsoft sign-in</h2>
      <p>
        Use the Microsoft tenant and person identity approved for your
        engagement.
      </p>
      <label>
        Approved invitation email
        <input
          type="email"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value.toLowerCase())}
        />
      </label>
      <button disabled={busy}>
        {busy ? "Opening Microsoft…" : "Continue with Microsoft"}
      </button>
      {error && <p role="alert">{error}</p>}
    </form>
  );
}

const callbacks = new Map<string, Promise<unknown>>();
export function VendorMicrosoftCallback() {
  const { apiBaseUrl } = useAuth();
  const [error, setError] = useState("");
  const [callback] = useState(() => {
    const query = new URLSearchParams(window.location.search);
    return {
      code: query.get("code"),
      state: query.get("state"),
      error: query.has("error"),
    };
  });
  useEffect(() => {
    const { code, state } = callback;
    window.history.replaceState(null, "", "/vendors/microsoft-callback");
    if (!code || !state || callback.error) {
      setError("Microsoft sign-in did not complete. Start again.");
      return;
    }
    const key = state;
    let request = callbacks.get(key);
    if (!request) {
      request = vendorRequest(apiBaseUrl, "vendor-identity/microsoft/finish", {
        method: "POST",
        body: JSON.stringify({ code, state }),
      });
      callbacks.set(key, request);
    }
    let alive = true;
    void request
      .then(() => {
        if (alive) window.location.replace("/vendors/workspace");
      })
      .catch((err) => {
        if (alive) {
          window.history.replaceState(null, "", "/vendors/microsoft-callback");
          setError(err.message);
        }
      });
    return () => {
      alive = false;
    };
  }, [apiBaseUrl, callback]);
  return (
    <main className="vendor-workspace">
      <h1>Microsoft vendor sign-in</h1>
      {error ? (
        <>
          <p role="alert">{error}</p>
          <a href="/login">Start sign-in again</a>
        </>
      ) : (
        <p role="status">Verifying your approved identity…</p>
      )}
    </main>
  );
}
